export const fadeInKeyframes = [{ opacity: 0 }, { opacity: 1 }];
export const fadeOutKeyframes = [{ opacity: 1 }, { opacity: 0 }];
